import React from "react";
import { Link } from "react-router-dom";
import { Rating } from "@material-ui/core";
import { Star } from "@material-ui/icons";

import "./Restaurant.css";

export default function Restaurant(props) {
  return (
    <div>
      {props.showLink ? (
        <Link to={`/restaurants/${props.id}`}>
          <h4>{props.name}</h4>
        </Link>
      ) : null}

      {/* <h5>{props.rate}</h5>
      <p>
        <img src={props.imageUrl} alt="Loading" height="200" />
      </p>

      {props.description ? <p>{props.description}</p> : null}
      {props.address ? <p>{props.address}</p> : null}
      {props.city ? <p>{props.city}</p> : null}
      {props.contact ? <p>{props.contact}</p> : null}
      {props.website ? <p>{props.website}</p> : null} */}

      <div>
        <div className="property-card">
          <img
            className="property-image"
            src={props.imageUrl}
            alt="Loading"
            height="200"
          />

          <div className="property-description">
            <h5> {props.name} </h5>
            <Rating
              sx={{ color: "#000d30" }}
              value={props.rate}
              readOnly
              precision={0.1}
              emptyIcon={<Star style={{ opacity: 0.6 }} />}
            />

            {props.description ? (
              <p className="description" style={{ color: "#000020" }}>
                {props.description}
              </p>
            ) : null}
            <div className="info">
              {props.address ? (
                <h4 style={{ color: "#000020" }}>{props.address}</h4>
              ) : null}
              {props.city ? (
                <h3 style={{ color: "#000020" }}>{props.city}</h3>
              ) : null}
              {props.contact ? (
                <h3 style={{ color: "#000020" }}>{props.contact}</h3>
              ) : null}
            </div>
            {props.website ? (
              <h style={{ color: "#000020" }}>{props.website}</h>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
